module.exports = __webpack_public_path__ + "img/W7015-mod.37ca259f.jpg";